import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const TaskListMobilePopupStyles = makeStyles()((theme: Theme) => ({
  dialogContainer: {
    overflow: 'auto',
    '& .MuiDialog-paper': {
      margin: '20px',
      borderRadius: '5px',
    },
    '& .MuiDialog-container': {
      height: 'auto',
      top: '30px',
      position: 'relative',
    },
    '& .MuiBackdrop-root': {
      zIndex: 'auto',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '12px 0',
    },
  },
  assessmentColor: {
    color: theme.palette.primary.main,
  },
  okButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: '117px',
  },
  marginBottom20: {
    marginBottom: '20px',
  },
  iconColor: {
    '& path': {
      fill: theme.palette.text.primary,
    },
  },
  warningIconSpecs: {
    margin: `30px 0 16px 0`,
  },
}));
